import { Alert, Box, Button as MuiButton } from '@mui/material';
import { styled } from '@mui/system';

export const CodStepperContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  padding: 30px;
  padding-top: 40px;
`;

export const EditOrCreateButton = styled(MuiButton)`
  height: 30px;
  font-size: 13px;
`;

export const SidebarContainer = styled(Box)`
  & > div:first-child {
    padding: 0 16px;
  }
  padding-top: 20px;
  height: 100vh;
`;

export const SidebarContent = styled(Box)`
  flex: 1;
  overflow-y: auto;
  height: calc(100vh - 55px);
`;

export const SidebarScreenContainer = styled('div')(
  ({ theme }) => `
    display: flex;
    justify-content: space-between;
    padding: 20px 0 20px 10px;
    margin-left: 16px;
    margin-right: 16px;
    border-bottom: 1px solid ${theme.palette.brand.borderGrey};
    align-items: center;
  `,
);

export const TakeoverOptionsContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TakeoverScreenContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: auto;
  margin-bottom: 20px;
`;

export const CustomAlert = styled(Alert)`
  width: calc(100% - 32px);
  margin: 0 16px;
`;
